import React from "react";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody, TableHead } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { formatDate } from '../../../../../common/utils'


class Auth8021XTab extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { subtestStatsResults, classes, translate, user, profile } = this.props;
    let mainData = subtestStatsResults && subtestStatsResults.interfaces.find(item => { return item.rh === false; });
    let auth8021x = mainData.auth8021x;

    return (
      <div>
        <Grid container spacing={40}>
          <Grid item xs={5}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableheader_first} rowSpan={2}>
                    {translate("status")}
                  </TableCell>
                  <TableCell className={classes.tableheader_first}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {translate("info") + ":"}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {auth8021x && auth8021x.authstatus ? translate(auth8021x.authstatus) : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {translate("result_pr_status")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {auth8021x && auth8021x.portstatus ? translate(auth8021x.portstatus) : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {translate("eap_method") + ":"}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {auth8021x && auth8021x.eapmethod ? auth8021x.eapmethod : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {translate("phase2_method") + ":"}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {auth8021x && auth8021x.phase2method ? auth8021x.phase2method : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {translate("key_mgmt_used") + ":"}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {auth8021x && auth8021x.keymgmtused ? auth8021x.keymgmtused : ""}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={7}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableheader}>
                    {translate("result_testtime")}
                  </TableCell>
                  <TableCell className={classes.tableheader}>
                    {translate("event")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {auth8021x && auth8021x.logs &&
                  auth8021x.logs.length
                    ? auth8021x.logs.split("\n").map((item, k) => {
                        const parts = item.split("/");
                        const textColor = parts.length > 1 ? (parts[1] === "2" ? "green" : (parts[1] === "3" ? "red" : null)) : null;
                        return (
                          <TableRow key={k}>
                            <TableCell className={classes.tablecontent_first}>
                              {parts.length > 0 ? formatDate(parts[0]) : ""}
                            </TableCell>
                            <TableCell className={classes.tablecontent_first_wide}
                              style={{ color: textColor ? textColor : "black" }}>
                              {parts.length > 2 ? parts[2] : ""}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </div>
    );
  }
  componentWillMount() {
    const { auth8021xResults } = this.props;
    this.setState({ data: auth8021xResults });
  }
}

export default withStyles(styles)(Auth8021XTab);
